export type Language = 'es' | 'en';

export const DEFAULT_LANGUAGE: Language = 'es';

export type LanguagesObject = Record<Language, string>;

export type AnyLanguageObject = Partial<LanguagesObject>;

//

export type LocaleCode = 'es_ES' | 'en_US';

export type LocaleConfigKey = 'ES' | 'EN';

const LOCALES_CONFIG: Record<LocaleConfigKey, LocaleCode> = {
    ES: 'es_ES',
    EN: 'en_US',
} as const;

export const LOCALE_KEYS = Object.keys(LOCALES_CONFIG).map((locale) => locale.toLowerCase() as Language);

export function getLocaleCode(localeKey: string, withHyphen?: false): LocaleCode;
export function getLocaleCode(localeKey: string, withHyphen: true): string;
export function getLocaleCode(localeKey: string, withHyphen = false): LocaleCode | string {
    const localeCode = LOCALES_CONFIG[localeKey.toUpperCase() as LocaleConfigKey] ?? LOCALES_CONFIG.ES;
    return withHyphen ? localeCode.replace('_', '-') : localeCode;
}
